import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Offer} from '../../../../../../core/models/offer/offer.model';
import {OffersTableColumnKey} from '../../../../../../core/services/impl/offers-table.service';
import {OfferRecommendationType} from '../../../../../../core/consts/offer-recommendation-type.enum';
import {OfferRecommendationConfig} from '../../../../../../core/models/offer/offer-recommendation-config';
import {OfferRecommendationsService} from '../../../../../../core/services/impl/offer-recommendations.service';
import {NextOffersSectionStateService} from '../../../../../../core/services/impl/section-services/next-offers/next-offers-section-state.service';

@Component({
  selector: 'app-offers-table-cell',
  templateUrl: './offers-table-cell.component.html',
  styleUrls: []
})
export class OffersTableCellComponent implements OnInit {

  @Input() offer: Offer;
  @Input() columnKey: OffersTableColumnKey;
  @Input() selected: boolean;
  @Output() select: EventEmitter<OffersTableSelectEvent> = new EventEmitter<OffersTableSelectEvent>();
  @Output() confirmSelection: EventEmitter<void> = new EventEmitter<void>();

  recommendationConfig: OfferRecommendationConfig | null;
  cssClassSuffix: string | null;
  recommendationActive: boolean;

  get selectable(): boolean {
    return !!this.offer && !this.selected;
  }

  constructor(private offerRecommendationsService: OfferRecommendationsService,
              private offerSectionStateService: NextOffersSectionStateService) { }

  ngOnInit() {
    const recommendationType = this.offer ? this.offerRecommendationsService.getOfferRecommendationType(this.offer) : null;
    this.recommendationConfig = recommendationType ? this.offerRecommendationsService.getConfig(recommendationType) : null;
    this.recommendationActive = recommendationType ? !!this.offerRecommendationsService.getRoleConfig(recommendationType) : false;
    this.cssClassSuffix = this.getCssClassSuffix(recommendationType);
  }

  selectOffer(): void {
    if (!!this.offer) {
      this.select.emit({
        offer: this.offer,
        columnKey: this.columnKey
      });
    }
  }

  buy(): void {
    this.confirmSelection.emit();
  }

  showOfferDetails(): void {
    this.offerSectionStateService.showOfferDetails(this.offer);
  }

  private getCssClassSuffix(recommendationType: OfferRecommendationType): string | null {
    if (this.recommendationConfig) {
      const roleConfig = this.offerRecommendationsService.getRoleConfig(recommendationType);
      return roleConfig ? roleConfig.cssClassSuffix : null;
    }
    return null;
  }

}

export interface OffersTableSelectEvent {
  offer: Offer;
  columnKey: OffersTableColumnKey;
}
